import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'contact-single-quotes',
		prop1: '',
		prop2: '',
		prop3: [],

		contactDetails: [],
		contactDetailsComp: '0',

		contactQuotes: [],
		contactQuotesComp: '0',


	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2; state.prop3 = payload.prop3},

		setContactDetails(state, payload) { state.contactDetails = payload.info; state.contactDetailsComp = payload.info1; },
		setContactDetailsComp(state, payload) { state.contactDetailsComp = payload.info1; },
		
		setContactQuotes(state, payload) { state.contactQuotes = payload.info; state.contactQuotesComp = payload.info1; },
		setContactQuotesComp(state, payload) { state.contactQuotesComp = payload.info1; },
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3, })  },

		getContactDetails(context, payload) {
			context.commit("setContactDetailsComp", { info1: '0' }) 
			axios.get('/utility/user/contact/getspecificcontact/' + payload.contact )
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setContactDetails", { info: b, info1: '1' }) 
	          	});
		},

		getContactQuotes(context, payload) {
			context.commit("setContactQuotesComp", { info1: '0' }) 
			axios.get('/utility/user/quote/getquotesbycontact/' + payload.contact )
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setContactQuotes", { info: b, info1: '1' }) 
	          	});
		},

		getContactQuotes(context, payload) {
			context.commit("setContactQuotesComp", { info1: '0' }) 
			axios.get('/utility/user/quote/getquotesbycontact/' + payload.contact )
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setContactQuotes", { info: b, info1: '1' }) 
	          	});
		},
		
	}

})